import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React, { useState } from 'react';
import DeletedMessage from './DeletedMessage';
import MessageMedia from './MessageMedia';
import TextMessage from './TextMessage';
import UnsupportedMessage from './UnsupportedMessage';
import { isOwnMessage } from './messageIdentity';
import { resolveMessageMediaUri } from './resolveMessageMediaUri';

const authorCaption = (message) => {
   const user = message && message.user;
   if (!user) return 'Unknown';
   return user.name || user.fullName || user.caption || (user._id != null ? `User #${user._id}` : 'Unknown');
};

const MessageRow = ({ message, currentUser, formatDateTime, onRetry, onRemove, submitting, actions = [] }) => {
   const [anchorEl, setAnchorEl] = useState(null);
   const own = isOwnMessage({ currentUser, message });
   const hasMedia = ['image', 'audio', 'video'].some((mediaType) => Boolean(resolveMessageMediaUri({ message, mediaType })));
   const hasSupportedContent = Boolean(message.text || hasMedia);
   const classes = [
      'chatterbox-message',
      own ? 'own' : 'other',
      message.deleted ? 'deleted' : '',
      message.pending ? 'pending' : '',
      message.failed ? 'failed' : ''
   ].filter(Boolean).join(' ');

   return (
      <article className={classes} data-message-id={message._id}>
         <header>
            <strong>{authorCaption(message)}</strong>
            <time>{formatDateTime ? formatDateTime(message.createdAt) : message.createdAt}</time>
            {message.readOnly && !message.deleted && <span className='chatterbox-imported'>Imported</span>}
            {actions.length > 0 && (
               <>
                  <IconButton
                     className='chatterbox-message-actions-button'
                     size='small'
                     aria-label='Note actions'
                     onClick={(event) => setAnchorEl(event.currentTarget)}
                  >
                     <MoreVertIcon fontSize='small' />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                     {actions.map((action) => (
                        <MenuItem
                           key={action.label}
                           onClick={() => {
                              setAnchorEl(null);
                              action.onClick(message);
                           }}
                        >
                           {action.label}
                        </MenuItem>
                     ))}
                  </Menu>
               </>
            )}
         </header>
         {message.deleted ? (
            <DeletedMessage />
         ) : (
            <div className='chatterbox-message-content'>
               <TextMessage text={message.text} />
               <MessageMedia message={message} />
               {!hasSupportedContent && <UnsupportedMessage />}
            </div>
         )}
         {message.pending && <div className='chatterbox-message-status'>Sending…</div>}
         {message.failed && (
            <div className='chatterbox-message-failure'>
               <span>Could not send.</span>
               {onRetry && <Button size='small' color='primary' disabled={submitting} onClick={() => onRetry(message)}>Retry</Button>}
               {onRemove && <Button size='small' disabled={submitting} onClick={() => onRemove(message)}>Remove</Button>}
            </div>
         )}
      </article>
   );
};

export default MessageRow;
